import resolvePromise from '../helper/resolved_promise';
import { FilterActions } from '../constants/filter/filter_actions';
import Dispatcher from '../dispatcher';

function updateFiltersAction(updatedFilters) {
    Dispatcher.handleCatalogFilterAction({
        type: FilterActions.UPDATE_FILTER,
        payload: updatedFilters
    });

    return resolvePromise();
}

export {
    updateFiltersAction
};